import { IPOOTPVALIDATE_DATA, IPOOTPVALIDATE_ERROR_DATA, IPOOTPVALIDATE_HIDE_ERROR_DATA, IPOOTPVALIDATE_START_LOADER, IPOOTPVALIDATE_STOP_LOADER, } from "../interface/IpoOtpValidate";
const initState = {
    data: {},
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const IpoOtpValidate = (state = initState, action) => {
    switch (action.type) {
        case IPOOTPVALIDATE_DATA:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case IPOOTPVALIDATE_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case IPOOTPVALIDATE_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        case IPOOTPVALIDATE_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case IPOOTPVALIDATE_HIDE_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        default:
            return Object.assign({}, state);
    }
};
export default IpoOtpValidate;
